import React from 'react';
import StatePicker from '../../commonComponents/StatePicker';
import { LICENSE_FILTERS_V2 } from './utils';

export const CustomHeader = ({ filter, handleFilterChange }) => {
  const filters = LICENSE_FILTERS_V2();

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 20,
        marginTop: 32,
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          width: '100%',
          gap: 20,
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              minWidth: 140,
            }}
          >
            <p>State:</p>

            <StatePicker
              ariaLabel="State"
              style={{
                height: 32,
              }}
              value={filter.state}
              didSelect={(state) => handleFilterChange('state', state)}
            />
          </div>
        </div>
        {filters.map(({ key, label, options }) => (
          <div
            key={key}
            style={{
              display: 'flex',
              flexDirection: 'column',
              minWidth: 140,
            }}
          >
            <p>{label}:</p>

            <select
              aria-label={label}
              className="custom-select custom-select-lg"
              style={{ height: 32 }}
              value={filter[key]}
              onChange={(val) => {
                handleFilterChange(key, val.target.value !== 'all' ? val.target.value : '');
              }}
            >
              {options.map((option) => (
                <option key={option.code} value={option.code}>
                  {option.name}
                </option>
              ))}
            </select>
          </div>
        ))}
      </div>
    </div>
  );
};
